import React from 'react';
import { View } from 'react-native';
import { colors } from '../../../utils/theme';

export type NotificationIndicatorOwnProps = {
    shouldHide?: boolean;
};

export const NOTIFICATION_INDICATOR_SIZE = 10;

export type NotificationIndicatorProps = NotificationIndicatorOwnProps;

const NotificationIndicator: React.FC<NotificationIndicatorProps> = (props) => {
    if (props.shouldHide) return <View testID="no-notification-indicator" />;

    return (
        <View
            style={{
                backgroundColor: colors.Success,
                borderRadius: NOTIFICATION_INDICATOR_SIZE / 2,
                width: NOTIFICATION_INDICATOR_SIZE,
                height: NOTIFICATION_INDICATOR_SIZE,
                justifyContent: 'center',
                alignItems: 'center',
            }}
            testID="notification-indicator"
        ></View>
    );
};

export default React.memo(NotificationIndicator);
